// import Api from '@/api/axios-api.js'

export default {

  LOADING_ON (state) {
    state.loading = true
  },
  LOADING_OFF (state) {
    state.loading = false
  }

}



// WEBPACK FOOTER //
// ./src/store/mutations.js